import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import { DataCenter } from 'cio/models/account';
import AccountService from 'cio/services/account';

export default class extends Helper {
  @service account!: AccountService;

  compute([value]: [string]) {
    let url = new URL(value);

    if (this.account.current.dataCenter === DataCenter.EU) {
      url.searchParams.append('region', DataCenter.EU);
    }

    return url.toString();
  }
}
